import React from 'react';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import SubHeader from '../../components/Common/SubHeader/SubHeader';
import ContactBanner from '../../components/Contact/ContactBanner/ContactBanner';

const Contact = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <ContactBanner/>
            <Footer/>
        </div>
    );
};

export default Contact;